jQuery(document).ready(function ($) {
  var dragging = false,
    scrolling = false,
    resizing = false;

  // Cache jQuery objects
  var imageComparisonContainers = $('.dt-image-container');

  // Check if the .dt-image-container is in the viewport
  // If yes, animate it
  checkPosition(imageComparisonContainers);
  
  $(window).on('scroll', function () {
    if (!scrolling) {
      scrolling = true;
      (!window.requestAnimationFrame)
        ? setTimeout(function () { checkPosition(imageComparisonContainers); }, 100)
        : requestAnimationFrame(function () { checkPosition(imageComparisonContainers); });
    }
  });

  // Make the .cd-handle element draggable and modify .cd-resize-img width according to its position
  imageComparisonContainers.each(function () {
    var actual = $(this);
    drags(actual.find('.cd-handle'), actual.find('.cd-resize-img'), actual, actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-image-label[data-type="modified"]'));
  });

  // Update image labels' visibility
  $(window).on('resize', function () {
    if (!resizing) {
      resizing = true;
      (!window.requestAnimationFrame)
        ? setTimeout(function () { checkLabel(imageComparisonContainers); }, 100)
        : requestAnimationFrame(function () { checkLabel(imageComparisonContainers); });
    }
  });

  function checkPosition(container) {
    container.each(function () {
      var actualContainer = $(this);
      if ($(window).scrollTop() + $(window).height() * 0.5 > actualContainer.offset().top) {
        actualContainer.addClass('is-visible');
      }
    });
    scrolling = false;
  }

  function checkLabel(container) {
    container.each(function () {
      var actual = $(this);
      updateLabel(actual.find('.cd-image-label[data-type="modified"]'), actual.find('.cd-resize-img'), 'left');
      updateLabel(actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-resize-img'), 'right');
    });
    resizing = false;
  }

  // Draggable functionality
  function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
    dragElement.on("mousedown vmousedown touchstart", function (e) {
      dragElement.addClass('drag');
      resizeElement.addClass('resizable');

      var dragWidth = dragElement.outerWidth(),
        xPosition = dragElement.offset().left + dragWidth - ((e.type === 'touchstart') ? e.originalEvent.touches[0].pageX : e.pageX),
        containerOffset = container.offset().left,
        containerWidth = container.outerWidth(),
        minLeft = containerOffset + 10,
        maxLeft = containerOffset + containerWidth - dragWidth - 10;

      dragElement.parents().on("mousemove vmousemove touchmove", function (e) {
        if (!dragging) {
          dragging = true;
          (!window.requestAnimationFrame)
            ? setTimeout(function () {
              animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);
            }, 100)
            : requestAnimationFrame(function () {
              animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);
            });
        }
      }).on("mouseup vmouseup touchend", function () {
        dragElement.removeClass('drag');
        resizeElement.removeClass('resizable');
      });

      e.preventDefault();
    }).on("mouseup vmouseup touchend", function () {
      dragElement.removeClass('drag');
      resizeElement.removeClass('resizable');
    });
  }

  function animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
    var leftValue = ((e.type === 'touchmove') ? e.originalEvent.touches[0].pageX : e.pageX) + xPosition - dragWidth;
    // Constrain the drag element to move inside its container
    if (leftValue < minLeft) {
      leftValue = minLeft;
    } else if (leftValue > maxLeft) {
      leftValue = maxLeft;
    }

    var widthValue = ((leftValue + dragWidth / 2 - containerOffset) / containerWidth) * 100 + '%';

    $('.drag').css('left', widthValue).on("mouseup vmouseup touchend", function () {
      $(this).removeClass('drag');
      resizeElement.removeClass('resizable');
    });

    $('.resizable').css('width', widthValue);

    updateLabel(labelResizeElement, resizeElement, 'left');
    updateLabel(labelContainer, resizeElement, 'right');
    dragging = false;
  }

  function updateLabel(label, resizeElement, position) {
    // Ensure the label exists
    if (label.length === 0) {
      console.warn('Label element is missing!');  // Log if label is not found
      return;
    }

    if (position === 'left') {
      (label.offset().left + label.outerWidth() < resizeElement.offset().left + resizeElement.outerWidth()) 
        ? label.removeClass('is-hidden') 
        : label.addClass('is-hidden');
    } else {
      (label.offset().left > resizeElement.offset().left + resizeElement.outerWidth()) 
        ? label.removeClass('is-hidden') 
        : label.addClass('is-hidden');
    }
  }
});
